import * as React from 'react';
import Websocket from 'react-websocket';
import {useState} from 'react';
import {useEffect, useRef} from 'react';
import PulsoidClient from '../../../../../PulsoidClient';

export const HeartRateInteractor = ({onWaitingData, onConnected}) => {
  const [status, setStatus] = useState(HEART_RATE_WAITING_DATA);
  const [lastReceivedDate, setLastReceivedDate] = useState();
  const [url, setUrl] = useState();

  useEffect(() => {
    async function fetchData() {
      let user = await new PulsoidClient().getUserInfo();
      setUrl(user.endpoints.listen);
    }
    fetchData();
  }, []);

  useEffect(
    (_) => {
      if (status === HEART_RATE_WAITING_DATA && onWaitingData) {
        onWaitingData(status);
      }
    },
    [status]
  );

  useInterval(() => {
    if (Date.now() - lastReceivedDate > 30_000) {
      setStatus(HEART_RATE_WAITING_DATA);
    }
  }, 5000);

  if (url) {
    return (
      <div style={{display: 'none'}}>
        <Websocket
          onOpen={() => setStatus(HEART_RATE_WAITING_DATA)}
          onMessage={(msg) => {
            let data = JSON.parse(msg);
            if (status !== HEART_RATE_CONNECTED) {
              setStatus(HEART_RATE_CONNECTED);
            }
            setLastReceivedDate(data.timestamp);
            if (onConnected) {
              onConnected(data.data.heartRate);
            }
          }}
          onClose={() => setStatus(HEART_RATE_WAITING_DATA)}
          url={url}
          reconnect={true}
          reconnectIntervalInMilliSeconds={3000}
        />
      </div>
    );
  } else {
    return <></>;
  }
};

const HEART_RATE_WAITING_DATA = 'HEART_RATE_WAITING_DATA';
const HEART_RATE_CONNECTED = 'HEART_RATE_CONNECTED';

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
